import React from 'react';

import { isEmpty } from 'ramda';

import { Day } from './Day';
import { useActiveTripEventModal } from './functions';
import s from './index.module.css';
import { useTimelineContext } from './TimelineContext';

export const Timeline = () => {
  useActiveTripEventModal();

  const { timelineDays } = useTimelineContext();

  if (timelineDays === null || isEmpty(timelineDays)) {
    return (
      <div className={s.empty}>
        <div className={s.emptyTitle}>Start By Adding An Event</div>
        <p className={s.emptyText}>
          Once added, you can manage events from this Timeline View or the Calendar View to the right to easily shift or
          extend dates.
        </p>
        <p className={s['emptyText-mobile']}>
          Once added, you can manage events from this Timeline View or the Calendar View, which is available on desktop
          only.
        </p>
      </div>
    );
  }

  return (
    <div id="timeline">
      {timelineDays.map((day) => (
        <Day key={day.day} day={day} />
      ))}
    </div>
  );
};
